import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Icon } from "@iconify/react/dist/iconify.js";

function ToolNode({ data }: { data: any }) {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white dark:bg-default-100 border-2 border-stone-400 dark:border-default-300 w-60 h-12">
      <div className="flex justify-center items-center h-full">
        <div className="text-gray-500 dark:text-gray-400 text-center flex items-center gap-2">
          <Icon className="text-xl" icon="qlementine-icons:tool-16" />
          {data.name
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char: string) => char.toUpperCase())}
        </div>
      </div>

      <Handle className="w-16 !bg-gray-500" position={Position.Top} type="target" />
      <Handle className="w-16 !bg-gray-500" position={Position.Bottom} type="source" />
    </div>
  );
}

export default memo(ToolNode);
